import { useState, FormEvent } from 'react';
import { trackNewsletterConversion } from '../../../utils/analytics';

export default function ResourcesNewsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d66cve6nnp6hevao8i60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          email: email,
          source: 'resources-page'
        }).toString(),
      });

      if (response.ok) {
        setIsSuccess(true);
        setEmail('');
        // Track Google Ads conversion for newsletter signup
        trackNewsletterConversion('resources-page');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-amber-500 via-amber-600 to-orange-600">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
          <i className="ri-mail-star-line text-white" />
          <span className="text-white text-sm font-medium">Stay Updated</span>
        </div>

        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          Get New Resources Delivered Weekly
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-xl mx-auto">
          Join 5,000+ tradies receiving free guides, tips, and exclusive content straight to their inbox.
        </p>

        {isSuccess ? (
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8 max-w-md mx-auto">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-line text-3xl text-amber-600" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">You are subscribed!</h3>
            <p className="text-white/80">Check your inbox for a welcome email with your first free guide.</p>
          </div>
        ) : (
          <form
            id="resources-newsletter-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
          >
            <div className="flex-1 relative">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full px-6 py-4 bg-white rounded-full text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-4 focus:ring-white/30 text-base"
                required
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-4 bg-slate-900 text-white rounded-full font-semibold hover:bg-slate-800 transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap disabled:opacity-70"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin" />
                  <span>Subscribing...</span>
                </>
              ) : (
                <>
                  <span>Subscribe Free</span>
                  <i className="ri-arrow-right-line" />
                </>
              )}
            </button>
          </form>
        )}

        {error && (
          <p className="mt-4 text-white/90 bg-red-500/30 px-4 py-2 rounded-lg inline-block">
            {error}
          </p>
        )}

        <p className="mt-6 text-white/70 text-sm">
          <i className="ri-shield-check-line mr-1" />
          No spam, unsubscribe anytime. We respect your privacy.
        </p>
      </div>
    </section>
  );
}
